module.exports = {
  api: {
    API_URL_LOCAL: "https://painel.evomap.com.br/api",
    API_URL: "https://painel.evomap.com.br/api"
//"https://jotapix.app.br",
// "http://192.168.0.161:3001",
  },
};
